import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { getHarmonyDocumentCollection } from '../getCollections'
import type { HarmonyPlanDocumentMutationContext } from './useHarmonyPlanContext.createDocument'

const logger = useRhythmicLogger('useHarmonyPlanContext:deleteDocument')

export function handleDeleteHarmonyPlanDocument(
  documentId: string,
  context: HarmonyPlanDocumentMutationContext,
): Transaction {
  if (!documentId) throw new Error('Document identifier is required to delete a harmony plan document')

  const { workspaceId, planId } = context

  if (!workspaceId) throw new Error('Workspace identifier is required to delete a harmony plan document')

  if (!planId) throw new Error('Harmony plan identifier is required to delete a document')

  const collection = getHarmonyDocumentCollection(context.planId)

  try {
    const transaction = collection.delete(documentId)
    return transaction
  } catch (error) {
    logger.error('Failed to delete harmony plan document', {
      planId,
      workspaceId,
      documentId,
      error,
    })
    if (error instanceof Error) throw error

    throw new Error('Failed to delete harmony plan document', { cause: error })
  }
}
